<template>
  <button class="btn btn-default btn-primary has-text-weight-semibold" type="button">
    <span :class="{ invisible: processing }">
      <slot></slot>
    </span>
    <span
      v-if="processing"
      class="absolute"
      style="top: 50%; left: 50%; transform: translate(-50%, -50%)"
    >
      <loader width="32" />
    </span>
  </button>
</template>

<script>
  export default {
    props: {
      processing: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
